import noodleApiClient, { ApiDefinition } from '@noodleApi';

type Input = ApiDefinition['/creators/{creatorId}/team-member/{teamMemberId}']['PUT']['params'] & ApiDefinition['/creators/{creatorId}/team-member/{teamMemberId}']['PUT']['body'];

const updateCreatorTeamMember = async ({ creatorId, teamMemberId, role }: Input): Promise<void> => {
  await noodleApiClient.put(`/creators/${creatorId}/team-member/${teamMemberId}`, { role });
};

// eslint-disable-next-line import/no-unused-modules
export default updateCreatorTeamMember;
